/* Yuvakart — make the whole card clickable, image included.

   Most sections only wrap the image and the title in links, leaving
   price, rating, badges and padding dead. This binds each card to its
   own primary link while ignoring every real control inside it, so
   Add to cart, quick-add forms and wishlist hearts still work. */
(function(){

  /* card wrapper  ->  selector for the link it should follow */
  var MAP = [
    /* homepage product cards */
    ['.bs__card',     '.bs__name, .bs__imgwrap'],
    ['.cd__card',     '.cd__name, .cd__imgwrap'],
    /* article cards */
    ['.gd__card',     '.gd__link, .gd__media'],
    ['.bl__feat',     '.bl__ft a, .bl__more, .bl__featimg'],
    /* theme product grids — related products, collection pages, search */
    ['.card-wrapper', 'a.full-unstyled-link, .card__heading a, .card__media a'],
    ['.card',         'a.full-unstyled-link, .card__heading a, .card__media a']
  ];

  /* real controls — let them do their own job */
  var SKIP = 'a, button, input, select, textarea, label, form,' +
             '.yk-heart, .bs__add, .cd__add, .bs-add-form, .cd-add-form,' +
             '.quick-add, .quick-add__submit, [role="button"]';

  function primaryHref(card, linkSel){
    var el = card.querySelector(linkSel);
    if (!el) return null;
    var href = el.getAttribute('href');
    if (!href || href === '#' || href.indexOf('javascript:') === 0) return null;
    return href;
  }

  function bind(card, linkSel){
    if (card.getAttribute('data-ykclick')) return;
    /* skip cards that are themselves a link — they already work */
    if (card.tagName === 'A') { card.setAttribute('data-ykclick','1'); return; }

    var href = primaryHref(card, linkSel);
    if (!href) return;

    card.setAttribute('data-ykclick', '1');
    card.style.cursor = 'pointer';

    card.addEventListener('click', function(e){
      if (e.target.closest && e.target.closest(SKIP)) return;
      var sel = window.getSelection && window.getSelection().toString();
      if (sel && sel.length > 2) return;
      if (e.metaKey || e.ctrlKey || e.shiftKey){
        window.open(href, '_blank', 'noopener');
        return;
      }
      window.location.href = href;
    });

    card.addEventListener('auxclick', function(e){
      if (e.button !== 1) return;
      if (e.target.closest && e.target.closest(SKIP)) return;
      window.open(href, '_blank', 'noopener');
    });
  }

  /* Some overlays sit on top of the artwork and swallow clicks.
     Anything purely decorative should never intercept a tap. */
  var DECOR = '.card__media::after, .ce__scrim, .ce__glare, .ce__frame,' +
              '.gd__card::after, .bl__glare';
  function freeDecor(){
    var els = document.querySelectorAll(
      '.ce__scrim, .ce__glare, .ce__frame, .bl__glare, .bs__rank, .cd__rank, .gd__chip, .card__badge'
    );
    for (var i = 0; i < els.length; i++){
      els[i].style.pointerEvents = 'none';
    }
  }

  function run(){
    for (var i = 0; i < MAP.length; i++){
      var cards = document.querySelectorAll(MAP[i][0]);
      for (var j = 0; j < cards.length; j++) bind(cards[j], MAP[i][1]);
    }
    freeDecor();
  }

  if (document.readyState === 'loading'){
    document.addEventListener('DOMContentLoaded', run);
  } else { run(); }

  setTimeout(run, 400);
  setTimeout(run, 1200);
  window.addEventListener('load', run);

  try {
    new MutationObserver(function(){ run(); })
      .observe(document.body, { childList:true, subtree:true });
  } catch(e){}
})();